import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  // {
  //   path: "",
  //   title: "MENUITEMS.MAIN.TEXT",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },
  // ========Use Path to update the route related information
  // {
  //   path: "package/offer-package",
  //   title: "MENUITEMS.OFFERPACKAGE.TEXT",
  //   iconType: "feather",
  //   icon: "assets/images/icons/offer_package_ic.svg",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  //   userType:['company'],
  //   itemName:'offer_package',
  // },
  {
    path: "manager/dashboard",
    title: "MENUITEMS.MANAGER.DASHBOARD",
    iconType: "feather",
    icon: "assets/images/sidebar/dashboard.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['manager'],
    itemName: 'manager_dashboard',
  },
  {
    path: "manager/employee-management",
    title: "MENUITEMS.MANAGER.EMPLOYEEMANAGEMENT",
    iconType: "feather",
    icon: "assets/images/sidebar/employee_mgt.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['manager'],
    itemName: 'manager_employee_management',
  },
  {
    path: "manager/coursework-management",
    title: "MENUITEMS.MANAGER.COURSEWORKMANAGEMENT",
    iconType: "feather",
    icon: "assets/images/sidebar/course_work_management_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['manager'],
    itemName: 'manager_coursework_management',
  },
  {
    path: "dashboard/dashboard2",
    title: "MENUITEMS.DASHBOARD.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/dashboard.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'dashboard'
  },
  {
    path: "user-management",
    title: "MENUITEMS.USERMANAGEMENT.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/user_management_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'user_management'
  },

  { 
    path: "department",
    title: "MENUITEMS.DEPARTMENT.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/departmen_management_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'dept_management'
  },
  {
    path: "course/course-store",
    title: "Course Store",
    iconType: "feather",
    icon: "assets/images/sidebar/individual_courses.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'course_store'
  },
  // any changes done here do for individual also as this menu is being used multiple times
  {
    path: "course/dashboard",
    title: "MENUITEMS.COURSEDASHBOARD.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/individual_courses.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    itemName: 'inh_course'
  },

  {
    path: "course/builder",
    title: "MENUITEMS.UNIVATELMS.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/course_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'course_builder'
  },
  {
    path: "course-playlist",
    title: "MENUITEMS.COURSEPLAYLIST.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/course_playlist.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'course_playlist'
  },
  {
    path: "package/purchase",
    title: "MENUITEMS.PACKAGE.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/manage_package.svg",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    userType: ['company'],
    itemName: 'package',
    submenu: [
      {
        path: "package/purchase",
        title: "MENUITEMS.PACKAGE.LIST.PURCHASEPACKAGE",
        iconType: "feather",
        icon: "assets/images/sidebar/certificate_management.png",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        submenu: [],
        userType: ['company'],
        itemName: 'purchase_package',
      },
      {
        path: "package/sell",
        title: "MENUITEMS.INDIVIDUAL.SELLCOURSES",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        submenu: [],
        userType: ['company'],
        itemName: 'sell_package',
      },
      {
        path: "package/my-package",
        title: "MENUITEMS.PACKAGE.LIST.MYPACKAGE",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        submenu: [],
        userType: ['company'],
        itemName: 'my_package',
      },
    ],
  },
  {
    path: "important-notice",
    title: "MENUITEMS.IMPNOTICE.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/important_notice.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'notice'
  },
  {
    path: "certificate-management",
    title: "MENUITEMS.CERTIFICATEMANAGEMENT.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/certificate_management_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'certificate'
  },
  {
    path: "forum-management",
    title: "MENUITEMS.FORUMMANAGEMENT.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/forum_management_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'forum'
  },
  {
    path: "staff-survey",
    title: "MENUITEMS.STAFFSURVEY.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/staff_survey_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'staff_survey'
  },
  // {
  //   path: "package/purchase",
  //   title: "MENUITEMS.PURCHASEPACKAGE.TEXT",
  //   iconType: "feather",
  //   icon: "assets/images/sidebar/certificate_management.png",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },

  {
    path: "document",
    title: "MENUITEMS.DOCUMENT.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/document_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company'],
    itemName: 'upload_document',
  },
  // {
  //   path: "recruitment",
  //   title: "MENUITEMS.RECRUITMENT.TEXT",
  //   iconType: "feather",
  //   icon: "assets/images/sidebar/recruitment_ic.svg",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  //   userType: ['company'],
  //   itemName: 'recruitment',
  // },
  {
    path: "/rec/job-cal",
    title: "New Recruitment",
    iconType: "feather",
    icon: "assets/images/sidebar/new-recrutment-ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    itemName: 'recruitment',
  },
  {
    path: "/rec/time-clock",
    title: "MENUITEMS.TIMECLOCK.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/timeclock-ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    // itemName:'recruitment_tc',
    itemName: 'time_management',
  },
  {
    path: "/rec/time-off",
    title: "MENUITEMS.TIMEOFF.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/time-off-ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    // itemName:'recruitment',
    itemName: 'time_off_management',
  },
  {
    path: "/rec/quick-task",
    title: "Quick Task",
    iconType: "feather",
    icon: "assets/images/sidebar/recruitment_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    itemName: 'qui_task',
  },
  {
    path: "/rec/workflow",
    title: "Work Flow",
    iconType: "feather",
    icon: "assets/images/sidebar/workflow-ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    itemName: 'workflow',
  },
  // {
  //   path: "/rec/user-event",
  //   title: "User Event",
  //   iconType: "feather",
  //   icon: "assets/images/sidebar/user-event-ic.svg",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  //   userType: ['company', 'manager'],
  //   itemName: 'recruitment',
  // },
  {
    path: "/rec/notification-management",
    title: "Notification",
    iconType: "feather",
    icon: "assets/images/sidebar/user-event-ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['company', 'manager'],
    itemName: 'recruitment',
  },

  // {
  //   path: "/chat",
  //   title: "MENUITEMS.CHAT.TEXT",
  //   iconType: "feather",
  //   icon: "assets/images/sidebar/recruitment_ic.svg",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  //   userType:['company'],
  //   itemName:'recruitment',
  // },
  {
    path: "individual/dashboard",
    title: "MENUITEMS.INDIVIDUAL.DASHBOARD",
    iconType: "feather",
    icon: "assets/images/sidebar/individual_dashboard.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'individual_dashboard'
  },
  {
    path: "individual/courses",
    title: "MENUITEMS.INDIVIDUAL.COURSES",
    iconType: "feather",
    icon: "assets/images/sidebar/individual_courses.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'individual_course'
  },

  {
    path: "individual/my-course",
    title: "MENUITEMS.INDIVIDUAL.MYCOURSE",
    iconType: "feather",
    icon: "assets/images/sidebar/individual_my_courses.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'individual_my_course'
  },
  {
    path: "individual/certificate-management",
    title: "MENUITEMS.INDIVIDUAL.CERTIFICATEMANAGEMENT",
    iconType: "feather",
    icon: "assets/images/sidebar/certificate_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'individual_certificate_management'
  },
  {
    path: "individual/purchase-history",
    title: "MENUITEMS.INDIVIDUAL.PURCHASEHISTORY",
    iconType: "feather",
    icon: "assets/images/sidebar/purchase_history_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'individual_purchase_history'
  },
  {
    path: "course/builder",
    title: "MENUITEMS.UNIVATELMS.TEXT",
    iconType: "feather",
    icon: "assets/images/sidebar/course_ic.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'course_builder'
  },
  {
    path: "package/sell",
    title: "MENUITEMS.INDIVIDUAL.SELLCOURSES",
    iconType: "feather",
    icon: "assets/images/sidebar/manage_package.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['individual'],
    itemName: 'sell_package',
  },
  // {
  //   path: "manager/manager-dashboard",
  //   title: "MENUITEMS.MANAGER.DASHBOARD",
  //   iconType: "feather",
  //   icon: "assets/images/sidebar/individual_dashboard.svg",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  //   userType:['manager'],
  //   itemName:'manager_dashboard',
  // },


  {
    path: "manager/event-management",
    title: "MENUITEMS.MANAGER.EVENTMANAGEMENT",
    iconType: "feather",
    icon: "assets/images/sidebar/event_mgt.svg",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    userType: ['manager'],
    itemName: 'manager_event_management',
  },
  // {
  //   path: "",
  //   title: "MENUITEMS.DASHBOARD.TEXT",
  //   iconType: "feather",
  //   icon: "home",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "dashboard/dashboard1",
  //       title: "MENUITEMS.DASHBOARD.LIST.DASHBOARD1",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "dashboard/dashboard2",
  //       title: "MENUITEMS.DASHBOARD.LIST.DASHBOARD2",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "advance-table",
  //   title: "MENUITEMS.ADVANCE-TABLE.TEXT",
  //   iconType: "feather",
  //   icon: "trello",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },
  // {
  //   path: "calendar",
  //   title: "MENUITEMS.CALENDAR.TEXT",
  //   iconType: "feather",
  //   icon: "calendar",
  //   class: "",
  //   groupTitle: false,
  //   badge: "New",
  //   badgeClass: "badge bg-blue sidebar-badge float-end",
  //   submenu: [],
  // },

  // Common Modules

  // {
  //   path: "",
  //   title: "MENUITEMS.APPS.TEXT",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },

  // {
  //   path: "task",
  //   title: "MENUITEMS.TASK.TEXT",
  //   iconType: "feather",
  //   icon: "check-circle",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },
  // {
  //   path: "contacts",
  //   title: "MENUITEMS.CONTACTS.TEXT",
  //   iconType: "feather",
  //   icon: "user-plus",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.EMAIL.TEXT",
  //   iconType: "feather",
  //   icon: "mail",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/email/inbox",
  //       title: "MENUITEMS.EMAIL.LIST.INBOX",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/email/compose",
  //       title: "MENUITEMS.EMAIL.LIST.COMPOSE",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/email/read-mail",
  //       title: "MENUITEMS.EMAIL.LIST.READ",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.MORE-APPS.TEXT",
  //   iconType: "feather",
  //   icon: "star",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "4",
  //   badgeClass: "badge bg-orange sidebar-badge float-end",
  //   submenu: [
  //     {
  //       path: "/apps/chat",
  //       title: "MENUITEMS.MORE-APPS.LIST.CHAT",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/apps/dragdrop",
  //       title: "MENUITEMS.MORE-APPS.LIST.DRAG-DROP",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/apps/contact-grid",
  //       title: "MENUITEMS.MORE-APPS.LIST.CONTACT-GRID",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/apps/support",
  //       title: "MENUITEMS.MORE-APPS.LIST.SUPPORT",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.WIDGETS.TEXT",
  //   iconType: "feather",
  //   icon: "gift",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/widget/chart-widget",
  //       title: "MENUITEMS.WIDGETS.LIST.CHART-WIDGET",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/widget/data-widget",
  //       title: "MENUITEMS.WIDGETS.LIST.DATA-WIDGET",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.COMPONENTS.TEXT",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.FORMS.TEXT",
  //   iconType: "feather",
  //   icon: "layout",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/forms/form-controls",
  //       title: "MENUITEMS.FORMS.LIST.CONTROLS",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/advance-controls",
  //       title: "MENUITEMS.FORMS.LIST.ADVANCE",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/form-example",
  //       title: "MENUITEMS.FORMS.LIST.EXAMPLE",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/form-validation",
  //       title: "MENUITEMS.FORMS.LIST.VALIDATION",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/wizard",
  //       title: "MENUITEMS.FORMS.LIST.WIZARD",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/editors",
  //       title: "MENUITEMS.FORMS.LIST.EDITORS",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.TABLES.TEXT",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/tables/basic-tables",
  //       title: "MENUITEMS.TABLES.LIST.BASIC",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/tables/material-tables",
  //       title: "MENUITEMS.TABLES.LIST.MATERIAL",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/tables/ngx-datatable",
  //       title: "MENUITEMS.TABLES.LIST.NGX-DATATABLE",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Charts",
  //   iconType: "feather",
  //   icon: "pie-chart",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "7",
  //   badgeClass: "badge bg-green sidebar-badge float-end",
  //   submenu: [
  //     {
  //       path: "/charts/echart",
  //       title: "Echart",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/apex",
  //       title: "Apex",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/chartjs",
  //       title: "ChartJS",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/ngx-charts",
  //       title: "Ngx-Charts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/gauge",
  //       title: "Gauge",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "User Interface (UI)",
  //   iconType: "feather",
  //   icon: "copy",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/ui/alerts",
  //       title: "Alerts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/badges",
  //       title: "Badges",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/chips",
  //       title: "Chips",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/modal",
  //       title: "Modal",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/buttons",
  //       title: "Buttons",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/expansion-panel",
  //       title: "Expansion Panel",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/bottom-sheet",
  //       title: "Bottom Sheet",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/dialogs",
  //       title: "Dialogs",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/cards",
  //       title: "Cards",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/labels",
  //       title: "Labels",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/list-group",
  //       title: "List Group",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/snackbar",
  //       title: "Snackbar",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/preloaders",
  //       title: "Preloaders",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/progressbars",
  //       title: "Progress Bars",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/tabs",
  //       title: "Tabs",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/typography",
  //       title: "Typography",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/helper-classes",
  //       title: "Helper Classes",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Medias",
  //   iconType: "feather",
  //   icon: "image",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/media/gallery",
  //       title: "Image Gallery",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Timeline",
  //   iconType: "feather",
  //   icon: "git-merge",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/timeline/timeline1",
  //       title: "Timeline 1",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/timeline/timeline2",
  //       title: "Timeline 2",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Icons",
  //   iconType: "feather",
  //   icon: "feather",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/icons/material",
  //       title: "Material Icons",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/icons/font-awesome",
  //       title: "Font Awesome",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Authentication",
  //   iconType: "feather",
  //   icon: "user-check",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/authentication/signin",
  //       title: "Sign In",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/signup",
  //       title: "Sign Up",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/forgot-password",
  //       title: "Forgot Password",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/locked",
  //       title: "Locked",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/page404",
  //       title: "404 - Not Found",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/page500",
  //       title: "500 - Server Error",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Extra Pages",
  //   iconType: "feather",
  //   icon: "anchor",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/extra-pages/profile",
  //       title: "Profile",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/pricing",
  //       title: "Pricing",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/invoice",
  //       title: "Invoice",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/faqs",
  //       title: "Faqs",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/blank",
  //       title: "Blank Page",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Maps",
  //   iconType: "feather",
  //   icon: "map-pin",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/maps/google",
  //       title: "Google Map",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Multi level Menu",
  //   iconType: "feather",
  //   icon: "chevrons-down",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [
  //     {
  //       path: "/multilevel/first1",
  //       title: "First",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //     {
  //       path: "/",
  //       title: "Second",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-sub-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [
  //         {
  //           path: "/multilevel/secondlevel/second1",
  //           title: "Second 1",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           submenu: [],
  //         },
  //         {
  //           path: "/",
  //           title: "Second 2",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-sub-menu2",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           submenu: [
  //             {
  //               path: "/multilevel/thirdlevel/third1",
  //               title: "third 1",
  //               iconType: "",
  //               icon: "",
  //               class: "ml-menu3",
  //               groupTitle: false,
  //               badge: "",
  //               badgeClass: "",
  //               submenu: [],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       path: "/multilevel/first3",
  //       title: "Third",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       submenu: [],
  //     },
  //   ],
  // },
];
